var alert = $(".si-alert");
$("[data-dismiss='alert']").on("click", function () {
  $(alert).hide();
});
